import React, { Component } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBListGroup,
  MDBListGroupItem
} from "mdbreact";
import LazyLoad from "react-lazyload";
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./style.module.scss";
import cx from "classnames";
import android from "~/assets/img/common/logo/googleplay.svg";
import ios from "~/assets/img/common/logo/appstore.svg";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";
import {
  urlSlide,
  LINK_ANDROID_APP,
  LINK_IOS_APP
} from "~/utils/manageResource";
export default class slideApplication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null
    };
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2
    });
  }

  render() {
    const info = get(partnerInfo, "info");
    const hospitalName = find(info, { key: "name" });

    // const settings1 = {
    //   arrows: false,
    //   infinite: true,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   autoplay: false,
    //   autoplaySpeed: 5000,
    //   speed: 900,
    //   animateIn: "fadeInLeft",
    //   touchThreshold: 100,
    //   lazyLoad: true,
    //   dots: false
    // };
    return (
      <div className={styles.slideApplication}>
        <MDBContainer>
          <MDBRow>
            <MDBCol sm="4">
              <div className={styles.utilities_about}>
                <h4>Ứng dụng {hospitalName.value}</h4>
                <p>
                  Đặt khám nhanh chóng, thanh toán dễ dàng, nhận phiếu trực
                  tuyến.
                </p>
                <MDBListGroup className={cx(styles.icons)}>
                  <MDBListGroupItem>
                    <a
                      href={LINK_ANDROID_APP}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LazyLoad height={50}>
                        <img src={android} alt="" />
                      </LazyLoad>
                    </a>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <a
                      href={LINK_IOS_APP}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LazyLoad height={50}>
                        <img src={ios} alt="" />
                      </LazyLoad>
                    </a>
                  </MDBListGroupItem>
                </MDBListGroup>
              </div>
            </MDBCol>
            <MDBCol sm="4" className={styles.box_img}>
              <div className={cx(styles.utilities_item, styles.box_img_item)}>
                {/* <Slider
                  asNavFor={this.state.nav2}
                  ref={slider => (this.slider1 = slider)}
                  {...settings1}
                  className={styles.box_slider_img}
                > */}
                <div className={styles.item_img}>
                  <img src={urlSlide} alt="" />
                </div>
                {/* </Slider> */}
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}
